export default class BourseEmploi {
  constructor() {
    // Template Bourse à l'emploi
    this.printBtn = document.querySelector('section.content .btn-wrapper .print');

    this.printPage();
  }

  printPage() {
    if (this.printBtn) {
      this.printBtn.addEventListener('click', () => {
        window.print();
      });
    }
  }
}